// extracted by css-extract-rspack-plugin
export default {"root":"root-p3D_Hq","input":"input-K0Dt3V text-body-base","leftIconContainer":"leftIconContainer-XGP2GR","clearContainer":"clearContainer-KYPIXf"};